// NESTY BLOOM — interacciones discretas
// Instalación: sube este archivo a Assets y agrega antes de </body> en theme.liquid:
// {{ 'nesty-interactions.js' | asset_url | script_tag }}

document.addEventListener('DOMContentLoaded', function () {
  // Scroll reveal para cualquier elemento con clase .nb-reveal
  var revealEls = document.querySelectorAll('.nb-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Acordeón FAQ accesible (usado en la página de producto)
  document.querySelectorAll('.nb-faq-item').forEach(function (item) {
    var trigger = item.querySelector('.nb-faq-question');
    var panel = item.querySelector('.nb-faq-answer');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
      item.classList.toggle('is-open', !expanded);
    });
  });
});
